module.exports = __webpack_public_path__ + "img/page1.75f0c0ca.png";